module.exports = __webpack_public_path__ + "static/media/dev-2.2e54a36f.png";